<template>
    <div id="myModal" class="modal">
        <div class="modal-content">
            <div class="container">
                <div class="row justify-content-end">
                    <div class="col-2">
                        <span class="close" @click="$emit('click', false)">&times;</span>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="text col">
                        <div class="header">Dane do wpłaty Darowizn na {{ systemConst.SYSTEM_ACCUSATIVE }}</div>
                        <div class="subheader">Wpłaty z&nbsp;Polski:</div>
                        <div class="text font-weight-bold">Nr konta:</div>
                        21 1750 0012 0000 0000 2060 1264
                        <div class="text font-weight-bold">Odbiorca:</div>
                        Stowarzyszenie WIOSNA <br> ul. Wielicka 20, 30-552 Kraków
                        <div class="text font-weight-bold">Tytułem:</div>
                        {{systemConst.PAYMENT_TITLE}}
                        <div class="subheader">Wpłaty z zagranicy:</div>
                        <div class="text font-weight-bold">Kod SWIFT/BIC:</div>
                        PPABPLPKXXX<br>
                        BNP Paribas Bank Polska<br>
                        ul. Kasprzaka 10/16, 01-211 Warszawa
                        <div class="text font-weight-bold">IBAN:</div>
                        PL 21 1750 0012 0000 0000 2060 1264
                        <div class="button-next">
                            <NextButton @click="$emit('click', false)" :extraClass="'button-position'">Zamknij</NextButton>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import systemConst from '@SYSTEM_CONSTANTS'
import NextButton from '../atoms/NextButton'

export default {
    name: 'FooterModal',
    data () {
        return {
            systemConst
        }
    },
    components: {
        NextButton
    }
}
</script>

<style lang="scss" scoped>
    /* The Modal (background) */
    .modal {
        display: block; /* Hidden by default */
        position: fixed; /* Stay in place */
        z-index: 1; /* Sit on top */
        left: 0;
        top: 0;
        width: 100%; /* Full width */
        height: 100%; /* Full height */
        overflow: auto; /* Enable scroll if needed */
        background-color: rgb(0,0,0); /* Fallback color */
        background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
    }

    /* Modal Content/Box */
    .modal-content {
        background-color: #fefefe;
        margin: 3% auto; /* 15% from the top and centered */
        padding: 20px;
        border: 1px solid #888;
        width: 80%; /* Could be more or less, depending on screen size */
    }

    /* The Close Button */
    .close {
        color: #aaa;
        float: right;
        font-size: 28px;
        font-weight: bold;
    }

    .close:hover,
    .close:focus {
        color: black;
        text-decoration: none;
        cursor: pointer;
    }

    .button-position {
        display: block;
        margin: auto;
        padding-top: 1.5rem;
        width: 120px;
    }

    /* Style content */
    .header {
        text-transform: uppercase;
        font-size: 20px;
    }

    .subheader {
        font-weight: bold;
        font-size: 18px;
        padding-top: 5px;
        padding-bottom: 10px;
        margin-top: 25px;
        border-top: 1px solid #aaa;
    }

    .text {
        font-size: 14px;
    }

</style>
